module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "back",
    on: {
      "click": _vm.go
    }
  }, [_c('span', {
    staticClass: "icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("返回")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e761d7c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Back.vue
// module id = 818
// module chunks = 0